module.exports = __webpack_public_path__ + "static/media/svg-3.14278bc1.svg";